/**
 * Initializes all custom accordions on the page.
 */
export const initAccordions = (): void => {
  const accordionContainers = document.querySelectorAll<HTMLElement>(
    "[data-accordion-container]"
  );

  if (accordionContainers.length === 0) {
    return;
  }

  accordionContainers.forEach((container) => {
    // Prevent double initialization if this script runs multiple times
    if (container.dataset.initialized === "true") return;
    container.dataset.initialized = "true";

    const accordionButtons = container.querySelectorAll<HTMLButtonElement>(
      "[data-accordion-button]"
    );

    accordionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".post-content-accordion__item");
        if (!item) return;

        // Optional: Close other open items (Accordion behavior vs Toggle behavior)
        // Uncomment to enforce "only one open at a time"
        /*
        const parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('.post-content-accordion__item.is-active').forEach(openItem => {
            if (openItem !== item) {
              openItem.classList.remove('is-active');
              openItem.querySelector<HTMLButtonElement>('[data-accordion-button]')?.setAttribute('aria-expanded', 'false');
            }
          });
        }
        */

        const isExpanded = item.classList.toggle("is-active");
        button.setAttribute("aria-expanded", String(isExpanded));
      });
    });
  });

  console.log(
    `[Accordion] Initialized ${accordionContainers.length} accordions.`
  );
};
